<template>
  <footer class="footer-version">
    <div class="row">
      <div class="col-md-12">
        <p class="p-version text-muted">{{ version }}</p>
      </div>
    </div>
  </footer>
</template>

<script>
import axiosApi from "@/axios";

export default {
  name: "Footer",
  data() {
    return {
      version: "",
    };
  },
  async created() {
    const versionApi = await axiosApi.get("/api/version").then((response) => {
      return response.data.data.version;
    });
    this.version = `v${versionApi}`;
  },
};
</script>

<style>
.footer-version {
  bottom: 0;
  position: fixed;
  width: 100%;
  display: flex;
  align-items: flex-end;
  flex-direction: column;
  height: 3vh;
}
.p-version {
  font-size: 0.8rem;
  margin-right: 10px;
}
</style>
